import { notification } from 'antd'
import parseError from 'helpers/parseServerError'
import { javaGetCookieInstance } from 'utils/requestJAVA'

export const getTotalOutstandingCommission = () => {
  return javaGetCookieInstance
    .get('/admin/v1/outstanding-invoice/totals', {
      params: {
        sheet: 'Total Outstanding commission',
      },
    })
    .catch((error) => {
      return error?.response?.status === 504
        ? notification.error({
            placement: 'bottomRight',
            duration: 10,
            message: 'Java Authentication failed',
            description:
              "Ensure you are accessing BO from the office. All routes that require JAVA won't work properly.",
          })
        : parseError(error, 'Cannot get total outstanding commission')
    })
}